import { bootstrapPersonVcard } from '@ng-icons/bootstrap-icons';
import { faBrandWhatsapp } from '@ng-icons/font-awesome/brands';
import { faSolidArrowPointer, faSolidEye } from '@ng-icons/font-awesome/solid';
import {
  ionAdd,
  ionCallOutline,
  ionCaretDownOutline,
  ionCaretUpOutline,
  ionCartOutline,
  ionCashOutline,
  ionCheckmark,
  ionChevronBack,
  ionChevronDown,
  ionChevronForward,
  ionChevronUp,
  ionClose,
  ionDesktopOutline,
  ionDesktopSharp,
  ionEllipsisHorizontalCircle,
  ionEyeOffOutline,
  ionEyeOutline,
  ionFilterOutline,
  ionGlobeOutline,
  ionInformationCircleOutline,
  ionKeyOutline,
  ionLinkSharp,
  ionLocationOutline,
  ionLockClosed,
  ionNavigateOutline,
  ionLockOpen,
  ionMailOutline,
  ionPersonCircleOutline,
  ionPersonOutline,
  ionPhonePortraitOutline,
  ionRefresh,
  ionRemove,
  ionSearch,
  ionShieldCheckmarkOutline,
  ionStatsChartOutline,
  ionTrash,
  ionTvOutline,
  ionTvSharp,
  ionVideocamOutline,
  ionWifiOutline,
  ionFlag,
  ionAddCircle,
  ionCalendarOutline,
  ionTimeOutline,
  ionCloseCircle,
  ionCheckmarkCircle,
  ionChatbubbleOutline,
  ionHomeOutline,
  ionRefreshOutline,
  ionCheckmarkCircleOutline,
  ionTrashOutline,
  ionAlertCircleOutline,
  ionChatbubblesOutline,
  ionHourglassOutline,
  ionSaveOutline,
  ionDocumentTextOutline,
  ionFingerPrintOutline,
  ionPeopleOutline,
  ionCardOutline,
  ionMapOutline,
  ionBriefcaseOutline,
  ionStarOutline,
  ionReceiptOutline,
  ionCloseOutline,
  ionSpeedometerOutline,
  ionFlagOutline,
  ionChatbubbleEllipsesOutline,
  ionCheckmarkDoneOutline,
  ionPersonAddOutline,
  ionSettingsOutline,
  ionEnterOutline,
  ionLeafOutline,
  ionBusinessOutline,
  ionWarningOutline,
} from '@ng-icons/ionicons';

export const ICONS = {
  ionAlertCircleOutline,
  ionCloseCircle,
  ionCheckmarkCircle,
  ionTimeOutline,
  ionLockOpen,
  ionDocumentTextOutline,
  ionChatbubbleEllipsesOutline,
  ionCloseOutline,
  ionPersonAddOutline,
  ionFlagOutline,
  ionCheckmarkDoneOutline,
  ionSettingsOutline,
  ionReceiptOutline,
  ionFingerPrintOutline,
  ionSpeedometerOutline,
  ionStarOutline,
  ionBriefcaseOutline,
  ionPeopleOutline,
  ionBusinessOutline,
  ionMapOutline,
  ionCardOutline,
  ionLockClosed,
  ionFilterOutline,
  ionChevronBack,
  ionChevronForward,
  ionCartOutline,
  faSolidArrowPointer,
  ionTvOutline,
  ionGlobeOutline,
  ionPhonePortraitOutline,
  ionEllipsisHorizontalCircle,
  ionSearch,
  ionCaretUpOutline,
  ionCaretDownOutline,
  ionCashOutline,
  ionInformationCircleOutline,
  ionTvSharp,
  ionWifiOutline,
  ionNavigateOutline,
  ionShieldCheckmarkOutline,
  ionDesktopOutline,
  ionVideocamOutline,
  ionDesktopSharp,
  ionCheckmark,
  bootstrapPersonVcard,
  ionPersonOutline,
  ionCallOutline,
  faBrandWhatsapp,
  ionMailOutline,
  ionLocationOutline,
  ionStatsChartOutline,
  ionAdd,
  ionClose,
  faSolidEye,
  ionRefresh,
  ionTrash,
  ionChevronDown,
  ionChevronUp,
  ionRemove,
  ionEyeOffOutline,
  ionEyeOutline,
  ionKeyOutline,
  ionPersonCircleOutline,
  ionLinkSharp,
  ionFlag,
  ionAddCircle,
  ionCalendarOutline,
  ionChatbubbleOutline,
  ionHomeOutline,
  ionRefreshOutline,
  ionCheckmarkCircleOutline,
  ionTrashOutline,
  ionChatbubblesOutline,
  ionHourglassOutline,
  ionSaveOutline,
  ionEnterOutline,
  ionLeafOutline,
  ionWarningOutline
};
